import React from "react";
import { modal } from "../common/modal";
import { Link } from "../lib/Link";
import { openContactSelector } from "../common/callUtil"
//import { showChat } from "../lib/synalio";
import { arrayToMap } from "../lib/masterData/util";

/* eslint-disable max-params */
export const header = (type, state, parent) => {
  let opened = state.sp_menu_open;
  const toggleMenu = () => {
    let s = !opened;
    opened = s;
    parent.setState({ sp_menu_open: opened });
  }
  const totop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }
  const path = () => {
    if (location.pathname == null || location.pathname == undefined || location.pathname.length < 2) {
      return "";
    }
    try {
      let path = location.pathname.slice(1);
      const prefpath = path.substring(0, path.indexOf('/'));
      const prefname = masterData.pref.bySlug[prefpath].name;
      const prefid = masterData.pref.bySlug[prefpath].prefId;
      try {
        path =  path.substring(path.indexOf('/')).slice(1);
        const citylinepath = path.substring(0 , path.indexOf('/'));
        let citylinename = "";
        if(citylinepath.startsWith('line-')){
          // サブディレクトリ第2層目が路線名の場合
          citylinename = masterData.line.bySlug[citylinepath.replace('line-', '')].name;
          try {
            path = path.substring(path.indexOf('/')).slice(1);
            const stationpath = path.substring(0 , path.indexOf('/'));
            const stationbyLine = masterData.station.byLine[citylinepath.replace('line-', '')];
            const stationbySlug = arrayToMap(stationbyLine, "slug");
            // サブディレクトリ第3層目が駅名の場合
            return stationbySlug[stationpath].name + "駅の";
          } catch(e) {
            // サブディレクトリ第3層目が駅名に変換できない場合
            return citylinename + "の";
          }
        } else{
          // サブディレクトリ第2層目が市町村町名の場合
          citylinename = masterData.city.byPrefAndSlug[prefid][citylinepath].name;
          return prefname + citylinename + "の";
        }
      } catch(e) {
        // サブディレクトリ1層目が都道府県名に変換でき
        // サブディレクトリ第2層目が路線名または市町村町名に変換できない場合
        return prefname + "の";
      }
    }
    catch (e) {
      // サブディレクトリ1層目が都道府県名に変換できない場合
      return "";
    }
  }
const renewalHeaderHtml = `
<div class="r_header">
    <div class="btn_totop">↑</div>
    <div class="r_header_inner">
        <div class="inner_left">
            <h1><a class="logo_top" href="/"><img src="images/renewal/logo_top.png" alt="ハローストレージ"></a></h1>
        </div>
        <div class="inner_right">
            <p><a data-target="modal1" class="modal_open"><img src="images/renewal/contact_link.svg" alt="お問合せ"></a></p>
        </div>
    </div>
</div>
<!-- ハンバーガーメニュー -->
<div class="openbtn1"><span></span><span></span><span></span></div>
<p class="menu_text"><img src="images/renewal/menu_text.svg" alt="MENU"></p>
<nav id="g-nav">
    <div id="g-nav-list">
        <ul>
            <li><a to="/list/" href="/list/">トランクルームを探す</a></li>
            <li><a to="/beginner/" href="/beginner/">初めての方</a></li>
            <li><a to="/flow/" href="/flow/">契約の流れ</a></li>
            <li> <a to="/lineup/" href="/lineup/">商品ラインナップ</a></li>
            <li><a data-target="modal1" class="modal_open">お問い合わせ</a></li>
            <li><a class="btn menu-btn" href="/mypage3/">マイページ <br class="br-sp">ログイン</a></li>
            <li><a class="btn menu-btn2" href="https://faq.hello-storage.com/">よくある質問</a></li>
        </ul>
    </div>
</nav>
<!-- お問合せモーダル -->
<!-- モーダル1 お問い合わせの種類を選択して下さい -->
<div id="modal1" class="modal_box">
    <p><a class="modal_close"><img src="images/renewal/ss_cross.png" alt=""></a></p>
    <h2>お問い合わせの種類を選択して下さい</h2>
    <div class="link_area">
        <ul>
            <li class="modal_link">
                <a data-target="modal2" class="modal_switch"><span>これからお申込みのお客様</span></a>
            </li>
            <li class="modal_link">
                <a data-target="modal3" class="modal_switch"><span>既にお申込み済みのお客様</span></a>
            </li>
        </ul>
    </div>
    <p class="modal_back"><a data-target="modal10" class="modal_switch">上記以外のお問い合わせ</a></p>
</div>

<!-- モーダル2 これからお申込みのお客様 -->
<div id="modal2" class="modal_box">
    <p><a class="modal_close"><img src="images/renewal/ss_cross.png" alt=""></a></p>
    <h2>お問い合わせの方法を選択して下さい</h2>
    <div class="link_area">
        <ul>
            <li class="modal_link modal_linkS">
                <a href="tel:0120524185">
                    <img src="images/renewal/big_phone.png">
                    <div>電話をかける</div>
                </a>
            </li>
            <li class="modal_link modal_linkS">
                <a href="/hello-storage/contact/" target="_blank" rel="noopener noreferrer">
                    <img src="images/renewal/envelope.png">
                    <div>メール</div>
                </a>
            </li>
        </ul>
    </div>
    <p class="modal_back"><a data-target="modal1" class="modal_switch"><span>前の画面に戻る</span></a></p>
</div>

<!-- モーダル3 既にお申込み済みのお客様  -->
<div id="modal3" class="modal_box">
    <p><a class="modal_close"><img src="images/renewal/ss_cross.png" alt=""></a></p>
    <h2>既にお申込み済みのお客様</h2>
    <p class="modal_link modal_link-mypage">
        <a class="item link" href="/mypage3/" target="_blank" rel="noopener noreferrer">
            <img src="images/renewal/post.png"><br>
            <span class="text1">マイページで簡単に<br class="br-sp">確認・変更できます！</span><br>
            <span class="text2">住所変更・料金確認・連絡先変更<br class="br-sp">・etc・・・等</span>
            <i class="arrow fas fa-chevron-right"></i>
        </a>                   
    </p>
    <div class="link_area link_area2">
        <ul>
            <li class="modal_link2"><a data-target="modal4" class="modal_switch"><span>鍵紛失トラブル</span></a></li>
            <li class="modal_link2"><a class="item link" href="/mypage3/" target="_blank" rel="noopener noreferrer"><span>解約の申し出</span></a></li>
            <li class="modal_link2"><a data-target="modal6" class="modal_switch"><span>移動・追加の検討中</span></a></li>
            <li class="modal_link2"><a data-target="modal7" class="modal_switch"><span>ご契約名義変更</span></a></li>
            <li class="modal_link2"><a data-target="modal8" class="modal_switch"><span>支払い方法変更</span></a></li>
            <li class="modal_link2"><a data-target="modal9" class="modal_switch"><span>その他ご意見・ご感想</span></a></li>
        </ul>
    </div>
    <p class="modal_back"><a data-target="modal1" class="modal_switch"><span>前の画面に戻る</span></a></p>
</div>

<!-- モーダル4 鍵紛失トラブル  -->
<div id="modal4" class="modal_box">
    <p><a class="modal_close"><img src="images/renewal/ss_cross.png" alt=""></a></p>
    <h2>鍵紛失トラブル</h2>
    <div class="link_area">
        <ul>
            <li class="modal_link">
                <a href="tel:0120524185">
                    <img src="images/renewal/big_phone.png">
                    <div>電話をかける</div>
                </a>
            </li>
        </ul>
    </div>
    <p>受付時間 9:30〜18:00</p>
    <p>※年末年始を除く月～日曜日を選択して下さい</p>
    <p class="modal_back"><a data-target="modal3" class="modal_switch"><span>前の画面に戻る</span></a></p>
</div>

<!-- モーダル5 解約の申し出  -->
<div id="modal5" class="modal_box">
    <p><a class="modal_close"><img src="images/renewal/ss_cross.png" alt=""></a></p>
    <h2>解約の申し出</h2>
    <h3><a href="tel:0120524185">0120-52-4185</a></h3>
    <p>受付時間 9:30〜18:00</p>
    <p>※年末年始を除く月～日曜日を選択して下さい</p>
    <p class="modal_back"><a data-target="modal3" class="modal_switch"><span>前の画面に戻る</span></a></p>
</div>

<!-- モーダル6 移動・追加の検討中  -->
<div id="modal6" class="modal_box">
    <p><a class="modal_close"><img src="images/renewal/ss_cross.png" alt=""></a></p>
    <h2>移動・追加の検討中</h2>
    <h3>お問い合わせの方法を選択して下さい</h3>
    <div class="link_area">
        <ul>
            <li class="modal_link modal_linkS">
                <a href="tel:0120524185">
                    <img src="images/renewal/big_phone.png">
                    <div>電話をかける</div>
                </a>
            </li>
            <li class="modal_link modal_linkS">
                <a href="/hello-storage/contact/" target="_blank" rel="noopener noreferrer">
                    <img src="images/renewal/envelope.png">
                    <div>メール</div>
                </a>
            </li>
        </ul>
    </div>
    <p class="modal_back"><a data-target="modal3" class="modal_switch"><span>前の画面に戻る</span></a></p>
</div>

<!-- モーダル7 ご契約名義変更  -->
<div id="modal7" class="modal_box">
    <p><a class="modal_close"><img src="images/renewal/ss_cross.png" alt=""></a></p>
    <h2>ご契約名義変更</h2>
    <div class="link_area">
        <ul>
            <li class="modal_link">
                <a href="tel:0120524185">
                    <img src="images/renewal/big_phone.png">
                    <div>電話をかける</div>
                </a>
            </li>
        </ul>
    </div>
    <p>受付時間 9:30〜18:00</p>
    <p>※年末年始を除く月～日曜日を選択して下さい</p>
    <p class="modal_back"><a data-target="modal3" class="modal_switch"><span>前の画面に戻る</span></a></p>
</div>

<!-- モーダル8 支払い方法変更  -->
<div id="modal8" class="modal_box">
    <p><a class="modal_close"><img src="images/renewal/ss_cross.png" alt=""></a></p>
    <h2>支払い方法変更</h2>
    <div class="link_area">
        <ul>
            <li class="modal_link">
                <a href="tel:0120524185">
                    <img src="images/renewal/big_phone.png">
                    <div>電話をかける</div>
                </a>
            </li>
        </ul>
    </div>
    <p>受付時間 9:30〜18:00</p>
    <p>※年末年始を除く月～日曜日を選択して下さい</p>
    <p class="modal_back"><a data-target="modal3" class="modal_switch"><span>前の画面に戻る</span></a></p>
</div>

<!-- モーダル9 その他ご意見・ご感想  -->
<div id="modal9" class="modal_box">
    <p><a class="modal_close"><img src="images/renewal/ss_cross.png" alt=""></a></p>
    <h2>その他ご意見・ご感想</h2>
    <div class="link_area">
        <ul>
            <li class="modal_link">
                <a href="/advicecard/" target="_blank" rel="noopener noreferrer">
                    <img src="images/renewal/advice_card.png">
                    <div>アドバイスカード</div>
                </a>
            </li>
        </ul>
    </div>
    <p class="modal_back"><a data-target="modal3" class="modal_switch"><span>前の画面に戻る</span></a></p>
</div>

<!-- モーダル10 上記以外のお問い合わせ -->
<div id="modal10" class="modal_box">
    <p><a class="modal_close"><img src="images/renewal/ss_cross.png" alt=""></a></p>
    <h2>上記以外のお問い合わせ</h2>
    <div class="link_area">
        <ul>
            <li class="modal_link">
                <a class="item link" href="/hello-storage/contact/?customer_kbn=2" target="_blank">
                    <div>ビジネスのご相談
                        <div class="subtext">（土地活用やパートナー提携）</div>
                    </div>
                </a>
            </li>
            <li class="modal_link">
                <a data-target="modal11" class="modal_switch">
                    <div>物件に関する苦情</div>
                </a>
            </li>
            <li class="modal_link">
                <a data-target="modal12" class="modal_switch">
                    <div>その他、ご意見</div>
                </a>
            </li>
        </ul>
    </div>
    <p class="modal_back"><a data-target="modal1" class="modal_switch"><span>前の画面に戻る</span></a></p>
</div>
<!-- モーダル11 物件に関する苦情 -->
<div id="modal11" class="modal_box">
    <p><a class="modal_close"><img src="images/renewal/ss_cross.png" alt=""></a></p>
    <h2>お問い合わせの方法を選択して下さい</h2>
    <div class="link_area">
        <ul>
            <li class="modal_link">
                <a href="/advicecard/" target="_blank" rel="noopener noreferrer">
                    <img src="images/renewal/advice_card.png">
                    <div>アドバイスカード</div>
                </a>
            </li>
        </ul>
    </div>
    <p class="modal_back"><a data-target="modal10" class="modal_switch"><span>前の画面に戻る</span></a></p>
</div>
<!-- モーダル12 その他、ご意見 -->
<div id="modal12" class="modal_box">
    <p><a class="modal_close"><img src="images/renewal/ss_cross.png" alt=""></a></p>
    <h2>お問い合わせの方法を選択して下さい</h2>
    <div class="link_area">
        <ul>
            <li class="modal_link modal_linkS">
                <a href="tel:0120524185">
                    <img src="images/renewal/big_phone.png">
                    <div>電話をかける</div>
                </a>
            </li>
            <li class="modal_link modal_linkS">
                <a href="/advicecard/" target="_blank" rel="noopener noreferrer">
                    <img src="images/renewal/advice_card.png">
                    <div>アドバイスカード</div>
                </a>
            </li>
        </ul>
    </div>
    <p class="modal_back"><a data-target="modal10" class="modal_switch"><span>前の画面に戻る</span></a></p>
</div>

<!-- お問合せモーダル ここまで -->
`;
  return (
    <div dangerouslySetInnerHTML={{__html: renewalHeaderHtml}}></div>
  );
};



// WEBPACK FOOTER //
// ./common/header.jsx